import React from 'react'
import "./SubStyle.css"

const Opera_fullManag = () => {
  return (
     <section className="SubServices">
     <h1 className="SubServices-title">Full Operational Management</h1>
      <p className="SubServices-pera">Focus on growing your business while we help manage the day-to-day operations. Our comprehensive operational management service supports staffing, compliance, quality assurance, performance monitoring, and strategic planning to ensure your service runs efficiently and delivers outstanding care.</p>
         <div className="btn-container">
        <button className="SubServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default Opera_fullManag
